import throttle from 'lodash.throttle'
import Sizes from '@/js/components/sizes'

export default class Navbar {
  constructor() {
    this.navbar = document.querySelector('nav.navbar.is-main')
    this.navbarMenu = document.querySelector('#nav-menu')
    this.navbarMini = document.querySelector('nav.navbar.is-mini')
    this.dropdown = null
    this.activeSubmenu = null
    this.themeBtns = this.navbarMenu.querySelectorAll('.button.is-light')
    this.toggleBtn = this.navbarMini.querySelector('.button.js-toggle')

    if (!Sizes.isMobile) {
      this.initMiniNav()
      if (this.themeBtns?.length) this.initHoverTheme()
    }

    this.initSubmenu()
  }

  initMiniNav() {
    const scrollLimit = 300

    this.toggleBtn.addEventListener('click', () => {
      this.navbar.classList.add('is-active')
      this.navbarMini.classList.remove('is-active')
    })

    const checkScroll = () => {
      const pageY = window.scrollY

      this.isMini = pageY > scrollLimit
      this.navbarMini.classList.toggle('is-active', this.isMini)
      this.navbar.classList.remove('is-active')
    }

    document.addEventListener('scroll', throttle(checkScroll, 100))
  }

  initSubmenu() {
    this.trigger = null
    // const isPermanent = (d) => d.dataset?.permanent != null

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-submenu]')

      if (trigger) {
        e.preventDefault()

        const dropdown = document.querySelectorAll(
          `.is-submenu[data-id="${trigger.dataset.submenu}"]`,
        )

        if (dropdown?.length) {
          if (
            this.activeSubmenu &&
            this.activeSubmenu != trigger.dataset.submenu
          ) {
            this.clearActiveDropdown()
          }

          if (trigger.dataset.group) {
            const sTrigger = document.querySelector(
              '[data-submenu][data-group="' +
                trigger.dataset.group +
                '"].is-black',
            )

            const sDropdown = document.querySelector(
              '.is-submenu:not(.is-hidden)',
            )

            if (sTrigger && sDropdown) {
              sDropdown.classList.add('is-hidden')
              sTrigger.classList.remove('is-black')
            }
          } else {
            // save active dropdown for closing on click outside on non-permanent submenus
            this.dropdown = dropdown
            this.trigger = trigger
            this.activeSubmenu = trigger.dataset.submenu
          }

          trigger.classList.toggle('is-black')
          dropdown.forEach((d) => d.classList.toggle('is-hidden'))
        }
      } else if (this.activeSubmenu) {
        this.clearActiveDropdown()
      }
    })
  }

  clearActiveDropdown() {
    this.trigger.classList.remove('is-black')
    this.dropdown.forEach((d) => d.classList.add('is-hidden'))
    this.trigger = null
    this.dropdown = null
    this.activeSubmenu = null
  }

  initHoverTheme() {
    if (!this.themeBtns[0].classList.contains('is-active')) {
      this.themeBtns.forEach((element) => {
        element.addEventListener('mouseenter', () => {
          this.themeBtns.forEach((e) => e.classList.add('is-active'))
        })

        element.addEventListener('mouseleave', () => {
          this.themeBtns.forEach((e) => e.classList.remove('is-active'))
        })
      })
    }
  }
}
